/**
 * 模块说明：销售折扣
 */
import { Service } from '@/tools'
export class TextbookDirectoryServer<T extends TOrder.TextbookDirectory> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.TextbookDirectory}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  private postUpload<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.TextbookDirectory}`, data?: TCommon.Json, toast?: string) {
    return this.post(
      {
        url: url,
        headers: {
          'Content-type': 'multipart/form-data',
        },
        method: 'post',
        data: data,
      },
      data,
      toast
    )
  }
  /**
   * 功能：教材征订提醒分页
   * /api/order/textbookDirectory/v1/selectPage

   */

  selectPage = <K extends T['ApiSelectPage']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiSelectPage', data)
  /**
   * 功能：教材征订提醒详情
   * /api/order/textbookDirectory/v1/textbookList
   */

  textbookList = <K extends T['ApiTextbookList']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiTextbookList', data)
  /**
   * 功能：教材征订提醒新增
   * /api/order/textbookDirectory/v1/addTextbook
   */

  addTextbook = <K extends T['ApiAddTextbook']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAddTextbook', data)

   /**
   * 功能：导入征订提醒校验
   * /api/order/textbookDirectory/v1/textbookCheck
   */

  textbookCheck = <K extends T['ApiTextbookCheck']>(data?: K['req']): Promise<K['res']> => this.postUpload('v1/ApiTextbookCheck', data)

}
